<div class="color-bar-container row">
  <div class="color-bar-item color-bar-1 col-3"></div>
  <div class="color-bar-item color-bar-2 col-3"></div>
  <div class="color-bar-item color-bar-3 col-3"></div>
  <div class="color-bar-item color-bar-4 col-3"></div>
</div>
